import fastInitializeComponent from 'Shared/fast-react-initialize';
import ListComponent from './list_component';
fastInitializeComponent('ListComponent', ListComponent);
